import React from 'react'
import SignatureComponent from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/body/SignatureComponent'
import { EMR_SECTION_IDS } from 'src/mentor/components/MentorPrescriptionTemplates/components/utils/emrSectionIds'
import { checkShowInPrintForEmrSection } from '../utils'

function getSignatureImageId(emrSections, reportData) {
  const section = emrSections?.find((s) => s?.id === EMR_SECTION_IDS.SIGNATURE)
  const fromSection =
    section?.signatureImageId ?? section?.properties?.signatureImageId ?? section?.signature
  if (fromSection) return fromSection
  return reportData?.signature ?? reportData?.signatureImageId ?? null
}

function getSignatureDoctorName(emrSections, reportData) {
  const section = emrSections?.find((s) => s?.id === EMR_SECTION_IDS.SIGNATURE)
  const fromSection = section?.doctorName ?? section?.properties?.doctorName
  if (fromSection) return fromSection
  return reportData?.doctorName ?? reportData?.mentorName ?? ''
}

/**
 * Renders the signature block for report print (screening, therapy, assessment) when the
 * signature EMR section is enabled for print. Use for therapy/screening/assessment printable views.
 */
export default function ReportSignatureBlock({
  emrSections,
  reportData,
  styleOverrides = {},
  reportType = 'screening-report',
}) {
  if (!emrSections || !checkShowInPrintForEmrSection(EMR_SECTION_IDS.SIGNATURE, emrSections)) {
    return null
  }
  const signatureImageId = getSignatureImageId(emrSections, reportData)
  const doctorName = getSignatureDoctorName(emrSections, reportData)
  if (!signatureImageId) return null

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, padding: '0 20px' }}>
      <SignatureComponent
        signatureSize={styleOverrides?.otherStyles?.signatureSize}
        signatureMediaId={signatureImageId}
        doctorName={doctorName}
      />
    </div>
  )
}
